var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCostInvoiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4126 4C17.5219 4 16.7998 6.14903 16.7998 8.8H18.4126C19.1899 8.8 19.5786 8.8 19.8192 8.53164C20.0598 8.26327 20.0179 7.90986 19.9341 7.20305C19.713 5.33714 19.1153 4 18.4126 4Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8003 8.84341V17.3166C16.8003 18.526 16.8003 19.1306 16.4307 19.3686C15.8268 19.7577 14.8931 18.9419 14.4235 18.6458C14.0355 18.4011 13.8416 18.2788 13.6262 18.2718C13.3936 18.2641 13.1961 18.3814 12.7769 18.6458L11.2482 19.6099C10.8358 19.8699 10.6296 20 10.4001 20C10.1707 20 9.96451 19.8699 9.55213 19.6099L8.0234 18.6458C7.6354 18.4011 7.44141 18.2788 7.2261 18.2718C6.99345 18.2641 6.79601 18.3814 6.37675 18.6458C5.9072 18.9419 4.97352 19.7577 4.36957 19.3686C4 19.1306 4 18.526 4 17.3166V8.84341C4 6.5602 4 5.4186 4.70296 4.7093C5.40592 4 6.53731 4 8.80011 4H18.4003",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3994 8.8C9.51568 8.8 8.79932 9.33726 8.79932 10C8.79932 10.6627 9.51568 11.2 10.3994 11.2C11.2831 11.2 11.9994 11.7373 11.9994 12.4C11.9994 13.0627 11.2831 13.6 10.3994 13.6M10.3994 8.8C11.096 8.8 11.6887 9.13392 11.9083 9.6M10.3994 8.8V8M10.3994 13.6C9.70269 13.6 9.11001 13.2661 8.89036 12.8M10.3994 13.6V14.4",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostInvoiceIcon);
export default __webpack_public_path__ + "static/media/cost_invoice_icon.4379e5a82a7c2ca6258d320e92aaf7f4.svg";
export { ForwardRef as ReactComponent };